import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiResponse, PagableData } from '../../models/common';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { AuthService } from '../auth/auth.service';
import { NoteInfo, ReqAddNote } from '../../models/information/note';
import { StatusEnum } from '../../models/common-enum';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  domain: string;
  constructor(private http: HttpClient, private authService: AuthService) {
    this.domain = environment.api.domain_information;
  }
  getNote(title?: string, status?: number, st_time?: string, en_time?: string, note_type_id?:number, hashtag?:string, note_by?:string, note_to?:string, note_by_id?:number, note_to_id?:number, page?: number, limit?: number, short?: number) {
    let params = new HttpParams();
    if (!_.isNil(page)) {
      params = params.append('page', page.toString());
    }
    if (!_.isNil(limit)) {
      params = params.append('limit', limit.toString());
    }
    if (!_.isNil(title)) {
      params = params.append('title', title.toString());
    }
    if (!_.isNil(st_time)) {
      params = params.append('st_time', st_time.toString());
    }
    if (!_.isNil(en_time)) {
      params = params.append('en_time', en_time.toString());
    }
    if (!_.isNil(note_type_id)) {
      params = params.append('note_type_id', note_type_id.toString());
    }
    if (!_.isNil(hashtag)) {
      params = params.append('hashtag', hashtag.toString());
    }
    if (!_.isNil(note_by)) {
      params = params.append('note_by', note_by.toString());
    }
    if (!_.isNil(note_to)) {
      params = params.append('note_to', note_to.toString());
    }
    if (!_.isNil(note_by_id)) {
      params = params.append('note_by_id', note_by_id.toString());
    }
    if (!_.isNil(note_to_id)) {
      params = params.append('note_to_id', note_to_id.toString());
    }
    if (!_.isNil(status)) {
      params = params.append('status', status.toString());
    }
    if (!_.isNil(short)) {
      params = params.append('short', short.toString());
    }
    const uri = `note`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      }),
      params: params
    };
    return this.http.get<ApiResponse<PagableData<NoteInfo[]>>>(url, httpOptions);
    // let url = 'assets/data/news_type.json';
    // return this.http.get<ApiResponse<PagableData<NewsTypeInfo[]>>>(url);
  }
  getNoteById(note_id?: number) {
    const uri = `note/${note_id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.get<ApiResponse<NoteInfo>>(url, httpOptions);
  }
  addNote(req: ReqAddNote): Observable<ApiResponse<any>> {
    const uri = `note`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.post<ApiResponse<any>>(url, req, httpOptions);
  }

  editNote(req: ReqAddNote, note_id?: number): Observable<ApiResponse<any>> {
    const uri = `note/${note_id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.put<ApiResponse<any>>(url, req, httpOptions);
  }
  deleteNote(note_id: number): Observable<ApiResponse<any>> {
    const uri = `note/${note_id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.delete<ApiResponse<any>>(url, httpOptions);
  }
  deleteNoteEditStatus(req: ReqAddNote, note_id?: number): Observable<ApiResponse<any>> {
    req.status = StatusEnum.Delete;
    const uri = `note/${note_id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.put<ApiResponse<any>>(url, req, httpOptions);
  }
}
